// MatchPopup.tsx
// Parent should pass suppressNotifications={true} when rendering this component
// so the push notification prompt is blocked while the match animation plays.
import { useState } from 'react';

interface MatchPopupProps {
  onClose: () => void;
  suppressNotifications?: boolean;
}

export default function MatchPopup({ onClose }: MatchPopupProps) {
  const [showButton, setShowButton] = useState(false);

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/80 z-50"
      onClick={showButton ? onClose : undefined}
    >
      <div className="relative w-full max-w-2xl flex flex-col items-center gap-4 px-4">
        <video
          autoPlay
          muted
          playsInline
          onEnded={() => setShowButton(true)}
          className="w-full rounded-2xl shadow-2xl"
        >
          <source src={"/match-animation2.mp4"} type="video/mp4" />
        </video>

        {showButton && (
          <button
            onClick={onClose}
            style={{
              padding: "14px 36px",
              fontFamily: "'Fredoka', sans-serif",
              fontSize: 20,
              fontWeight: 700,
              background: "#E05A3A",
              color: "#FFFFFF",
              border: "3px solid #1A1A1A",
              borderRadius: 100,
              boxShadow: "4px 4px 0px #1A1A1A",
              cursor: "pointer",
              transition: "all 0.1s ease",
            }}
          >
            Let's Go! →
          </button>
        )}
      </div>
    </div>
  );
}
